/* eslint-disable react/jsx-no-bind */
import { Routes, Route } from 'react-router-dom';

import { ProtectedRoutes } from '../components/ProtectedRoutes';

import { Layout } from '../pages/Layout';
import { Home } from '../pages/Home';
import { Reuniao } from '../pages/Reuniao';
import { GestaoUsuarios } from '../pages/GestaoUsuarios';
import { FolderComponent } from '../pages/BaseConhecimento';
import { UnprotectedRoutes } from '../components/UnprotectedRoutes';
import { Login } from '../pages/Login';
import { BoardDetails } from '../pages/Boards/BoardDetails';
import { RecoverPassword } from '../pages/RecoverPassword';
import { Boards } from '../pages/Boards';
import { InFolder } from '../pages/BaseConhecimento/components/InFolder';
import { Contas } from '../pages/Contas';
import { DetalhesConta } from '../pages/Contas/DetalhesConta';
import { DetalhesEmpresa } from '../pages/Contas/DetalhesEmpresa';
import { DetalhesUsuario } from '../pages/GestaoUsuarios/DetalhesUsuario';
import { Anotacoes } from '../pages/Anotacoes';
import { DadosPessoais } from '../pages/DadosPessoais';
import { Notificacoes } from '../pages/Notificacoes';
import { DetalhesReuniao } from '../pages/Reuniao/DetalhesReuniao';
import { Signatures } from '../pages/Signatures';
import { SuccessPageSignature } from '../components/SuccessPageSignature';
import { SuccessPageToSign } from '../components/SuccessPageToSign';
import { Logs } from '../pages/LogsPage';
import { SuccessOAuthZoom } from '../components/SuccessOauthZoom';
// import { Dados } from '../pages/Dados';

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <UnprotectedRoutes>
            <Login />
          </UnprotectedRoutes>
        }
      />
      <Route
        path="/recover-password/:email/:token"
        element={
          <UnprotectedRoutes>
            <RecoverPassword />
          </UnprotectedRoutes>
        }
      />
      <Route path="/home" element={<Layout />}>
        <Route
          path="/home"
          element={
            <ProtectedRoutes>
              <Home />
            </ProtectedRoutes>
          }
        >
          <Route
            path="contas"
            element={
              <ProtectedRoutes>
                <Contas />
              </ProtectedRoutes>
            }
          />
          <Route
            path="logs"
            element={
              <ProtectedRoutes>
                <Logs />
              </ProtectedRoutes>
            }
          />
          <Route
            path="contas/detalhes-conta/:id"
            element={
              <ProtectedRoutes>
                <DetalhesConta />
              </ProtectedRoutes>
            }
          />
          <Route
            path="contas/detalhes-empresa/:id"
            element={
              <ProtectedRoutes>
                <DetalhesEmpresa />
              </ProtectedRoutes>
            }
          />
          <Route
            path="dados-pessoais"
            element={
              <ProtectedRoutes>
                <DadosPessoais />
              </ProtectedRoutes>
            }
          />
          <Route
            path="notificacoes"
            element={
              <ProtectedRoutes>
                <Notificacoes />
              </ProtectedRoutes>
            }
          />
          <Route
            path="reunioes"
            element={
              <ProtectedRoutes>
                <Reuniao />
              </ProtectedRoutes>
            }
          />
          <Route
            path="reunioes/detalhes-reuniao/:id"
            element={
              <ProtectedRoutes>
                <DetalhesReuniao />
              </ProtectedRoutes>
            }
          />

          <Route
            path="gestao-usuarios"
            element={
              <ProtectedRoutes>
                <GestaoUsuarios />
              </ProtectedRoutes>
            }
          />
          <Route
            path="gestao-usuarios/detalhes-usuario/:id"
            element={
              <ProtectedRoutes>
                <DetalhesUsuario />
              </ProtectedRoutes>
            }
          />
          <Route
            path="boards"
            element={
              <ProtectedRoutes>
                <Boards />
              </ProtectedRoutes>
            }
          />
          <Route
            path="boards/board-details/:id"
            element={
              <ProtectedRoutes>
                <BoardDetails />
              </ProtectedRoutes>
            }
          />
          <Route
            path="base-conhecimento"
            element={
              <ProtectedRoutes>
                <FolderComponent />
              </ProtectedRoutes>
            }
          />
          <Route
            path="base-conhecimento/folder/:id"
            element={
              <ProtectedRoutes>
                <InFolder />
              </ProtectedRoutes>
            }
          >
            <Route
              path="folder/:id"
              element={
                <ProtectedRoutes>
                  <InFolder />
                </ProtectedRoutes>
              }
            />
          </Route>
          {/* <Route
            path="anotacoes"
            element={
              <ProtectedRoutes>
                <Anotacoes />
              </ProtectedRoutes>
            }
          /> */}

          <Route
            path="assinaturas"
            element={
              <ProtectedRoutes>
                <Signatures />
              </ProtectedRoutes>
            }
          />
        </Route>
      </Route>
      <Route
        path="assinaturas-sucesso/:id"
        element={
          <ProtectedRoutes>
            <SuccessPageSignature />
          </ProtectedRoutes>
        }
      />
      <Route path="assinado-sucesso" element={<SuccessPageToSign />} />
      <Route path="autenticacao-sucesso" element={<SuccessOAuthZoom />} />
      <Route
        path="assinatura-email/:document/:email"
        element={<SuccessPageToSign />}
      />
    </Routes>
  );
};

export default AppRoutes;
